import { render } from "./GlossaryComponent.vue?vue&type=template&id=081ff2f4&scoped=true"
import script from "./GlossaryComponent.vue?vue&type=script&lang=js"
export * from "./GlossaryComponent.vue?vue&type=script&lang=js"

import "./GlossaryComponent.vue?vue&type=style&index=0&id=081ff2f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081ff2f4"]])

export default __exports__